/** The most files one upload takes: the drop zone's limit, and the upload queue's on files still to upload. */
export const MAX_FILES_PER_UPLOAD = 100; // score-threshold-allow: a file count, not a score
